import { useRoutes } from "react-router-dom";
import Application from "pages/application/Application";
import Authentication from "pages/authentication/Authentication";
import ForgotPassword from "pages/forgot-password/ForgotPassword";
import Login from "pages/login/Login";
import Registration from "pages/registration/Registration";
import RegistrationCoBorrower from "pages/registration/RegistrationCoBorrower";
import Dashboard from "pages/dashboard/home/Dashboard";
import Documents from "pages/dashboard/documents/Documents";
import SharedDashboard from "components/shared-dashboard/SharedDashboard";
import Header from "components/ui/header/Header";
import RequireAuth from "features/RequireAuth";
import PublicRoute from "features/PublicRoute";
import Version from "pages/version/Version";
import Welcome from "pages/welcome/Welcome";
import RecoverPassword from "pages/recover-password/RecoverPassword";
import Mfa from "pages/MFA/MFA";
import RegistrationAuth from "pages/authentication/RegistrationAuth";
import AuthRouting from "components/auth-routing/AuthRouting";
import MyLoans from "pages/my-loans/MyLoans";
import RaNHRedirect from "pages/raNHRedirect/RaNHRedirect";
import External from "pages/external/External";
import UpdatePassword from "pages/update-password/UpdatePassword";
import UserGateway from "pages/user-gateway/UserGateway";
import ExternalRegistration from "pages/registration/ExternalRegistration";

export type Route =
  | "/"
  | "/authcode"
  | "/registrationAuth"
  | "/mfa"
  | "/registration"
  | "/registrationCoBorrower"
  | "/forgotpassword"
  | "/resetpassword"
  | "/thankyou"
  | "/path"
  | "/application"
  | "/apitests"
  | "/dashboard"
  | "/versions"
  | "/applicationcomplete"
  | "/los"
  | "/my-loans"
  | "/external"
  | "/interim-welcome"
  | "/updatePassword";

export function Routes() {
  const routes = useRoutes([
    {
      path: "/",
      element: <Header />,
      children: [
        {
          element: <PublicRoute />,
          children: [
            { index: true, element: <Login /> },
            {
              path: "registration",
              element: <Registration />,
            },
            {
              path: "registrationCoBorrower",
              element: <RegistrationCoBorrower />,
            },
            {
              path: "forgotpassword",
              element: <ForgotPassword />,
            },
            {
              path: "mfa",
              element: <Mfa />,
            },
            {
              path: "authcode",
              element: <Authentication />,
            },
            {
              path: "registrationAuth",
              element: <RegistrationAuth />,
            },
            { path: "resetpassword", element: <RecoverPassword /> }, 
            { path: "updatepassword", element: <UpdatePassword /> },
            { path: "start", element: <UserGateway /> },
            { path: "external-registration", element: <ExternalRegistration /> }
          ],
        },
        {
          element: <RequireAuth />,
          children: [
            { path: "post-auth", element: <AuthRouting /> },
            { path: "path", element: <Welcome /> },
            {
              path: "my-loans",
              element: <MyLoans />,
            },
            { path: "application", element: <Application /> },
            {
              path: "dashboard",
              element: <SharedDashboard />,
              children: [
                { index: true, element: <Dashboard /> },
                {
                  path: "documents",
                  element: <Documents />,
                },
              ],
            },
            {
              path: "external",
              element: <External />,
            },
          ],
        },
        { path: "versions", element: <Version /> },
      ],
    },
    {
      path: "/ra",
      element: <RaNHRedirect />,
    },
  ]);
  return routes;
}
